"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUserDetailsPositions = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userDetailsPositionsQuery = (0, graphql_tag_1.default) `
  query UserDetailsPositions($workspaceId: ID!, $userId: ID!) {
    role(workspace: $workspaceId, user: $userId) {
      user {
        positions {
          workspaceId
          purpose
          productionResourceType {
            name
            defaultHourlyProductivity
          }
          name
          shortName
          id
          employeeCount
          created
          color
          archived
        }
      }
    }
  }
`;
const requestUserDetailsPositions = async ({ workspaceId, userId }) => {
    const { data, errors } = await (0, apollo_1.query)(userDetailsPositionsQuery, {
        variables: {
            workspaceId,
            userId,
        },
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.role?.user;
};
exports.requestUserDetailsPositions = requestUserDetailsPositions;
